<template>
  <div>
    <loading-page
      :show-loading-page="showLoadingPage"
      :loading-message="loadingMessage"
    />
  </div>
</template>
<script>
import axios from "src/app-axios";
import LoadingPage from "src/views/components/LoadingPage.vue";

export default {
  name: "Logout",
  components: {
    "loading-page": LoadingPage,
  },

  data() {
    return {
      showLoadingPage: false,
      loadingMessage: "",
    };
  },
  mounted() {
    this.showLoadingPage = true;
    this.loadingMessage = "Logging Off...";
    setTimeout(() => {
      this.logOut();
    }, 2000);
  },
  methods: {
    async logOut() {
      await this.unsubscribeFromPush();
      await axios
        .post("api/devices/logout")
        .then(() => {
          this.unsubscribeFromPush();
          this.$store.dispatch("logout");
          this.$router.push({ name: "GetStarted" });
        })
        .catch(() => {
          this.$store.dispatch("logout");
          this.$router.push({ name: "GetStarted" });
        });
    },
    async unsubscribeFromPush() {
      try {
        const sw = await navigator.serviceWorker.ready;
        const subscription = await sw.pushManager.getSubscription();

        if (subscription) {
          await subscription.unsubscribe();
          console.log("🔕 Push subscription removed");
        }
      } catch (err) {
        console.error("❌ Failed to unsubscribe from push:", err);
      }
    },
  },
};
</script>
